{
  "three-acts": {
    "name": "Üç perde",
    "summary": "Kurulum, yüzleşme ve çözüm: çoğu romanın ve filmin paylaştığı yapı.",
    "bestFor": "Her tür ve basit tutmak istediğin bir ilk taslak için.",
    "metaTitle": "Üç perdeli hikâye şablonu — Musael",
    "metaDescription": "Kurulum, yüzleşme ve çözüm: çoğu romanın ve filmin paylaştığı yapı. Her tür ve basit tutmak istediğin bir ilk taslak için.",
    "acts": [
      {
        "title": "I. Perde: Kurulum",
        "synopsis": "Kahramanın kim olduğu, ne istediği ve sıradan hayatını sona erdiren olay.",
        "chapters": [
          {
            "title": "Sıradan dünya",
            "synopsis": "Kahraman kendi ortamındadır; hikâyenin sınayacağı arzusu ve kusuru ortaya çıkar.",
            "scenes": [
              {
                "title": "Açılış görüntüsü",
                "synopsis": "Herhangi bir şey değişmeden önce kahramandan bir kesit."
              },
              {
                "title": "Kanca",
                "synopsis": "Küçük ama tuhaf bir şey, yaklaşan sorunların habercisidir."
              }
            ]
          },
          {
            "title": "Tetikleyici olay",
            "synopsis": "Kahramanın görmezden gelemeyeceği olay.",
            "scenes": [
              {
                "title": "Harekete geçirici olay",
                "synopsis": "Sorun ortaya çıkar ve kendiliğinden kaybolmaz."
              },
              {
                "title": "Tereddüt",
                "synopsis": "Kahraman duraksar; neyi kaybedebileceğini görürüz."
              }
            ]
          },
          {
            "title": "Eşiği geçmek",
            "synopsis": "Kahraman kararının arkasında durur; artık geri dönmek kolay değildir.",
            "scenes": [
              {
                "title": "Karar",
                "synopsis": "Kahraman harekete geçmeyi seçer ve tanıdık olanı geride bırakır."
              }
            ]
          }
        ]
      },
      {
        "title": "II. Perde: Yüzleşme",
        "synopsis": "Kahraman dener, başarısız olur ve öğrenir; bu sırada tehlikeye attığı şeyler artar.",
        "chapters": [
          {
            "title": "Riskler yükseliyor",
            "synopsis": "Yeni kurallar, müttefikler ve düşmanlar; ilk zaferlerin bir bedeli vardır.",
            "scenes": [
              {
                "title": "İlk sınav",
                "synopsis": "Kahraman yeni dünyayla karşılaşır ve onu kısmen yanlış anlar."
              },
              {
                "title": "Müttefikler ve düşmanlar",
                "synopsis": "Kim yardım eder, kim engel olur ve neden?"
              }
            ]
          },
          {
            "title": "Orta nokta",
            "synopsis": "Hikâyenin ne hakkında olduğunu değiştiren bir tersine dönüş.",
            "scenes": [
              {
                "title": "Orta nokta",
                "synopsis": "Sahte bir zafer ya da yenilgi; kahraman tepki vermeyi bırakıp yön vermeye başlar."
              }
            ]
          },
          {
            "title": "Her şey dağılıyor",
            "synopsis": "Karşı taraf çemberi daraltır ve kahramanın kusuru ona pahalıya mal olur.",
            "scenes": [
              {
                "title": "Çember daralıyor",
                "synopsis": "Her plan dirençle karşılaşır; ilişkiler çatırdar."
              },
              {
                "title": "Her şey kaybedildi",
                "synopsis": "En dip nokta: hedef sonsuza dek erişilemez görünür."
              }
            ]
          }
        ]
      },
      {
        "title": "III. Perde: Çözüm",
        "synopsis": "Kahraman değişir, son sınavla yüzleşir ve yeni bir normal başlar.",
        "chapters": [
          {
            "title": "Doruk noktası",
            "synopsis": "II. Perde'de öğrenilen ders sayesinde kazanılan son yüzleşme.",
            "scenes": [
              {
                "title": "Son plan",
                "synopsis": "Kahraman öğrendiklerini bir araya getirir ve son bir girişimde bulunur."
              },
              {
                "title": "Doruk",
                "synopsis": "Sonucu belirleyen yüzleşme."
              }
            ]
          },
          {
            "title": "Yeni normal",
            "synopsis": "Kahraman ve dünya için nelerin değiştiği.",
            "scenes": [
              {
                "title": "Kapanış görüntüsü",
                "synopsis": "Açılış görüntüsünü yansıtarak kahramanın ne kadar yol aldığını gösterir."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "Kahramanın yolculuğu",
    "summary": "Maceraya çağrıdan eve dönüşe uzanan on iki aşama; ayrılış, erginlenme ve dönüş olarak gruplanır.",
    "bestFor": "Fantastik kurgu, macera ve arayış hikâyeleri için.",
    "metaTitle": "Kahramanın yolculuğu şablonu — Musael",
    "metaDescription": "Maceraya çağrıdan eve dönüşe on iki aşama: ayrılış, erginlenme ve dönüş. Fantastik kurgu, macera ve arayış hikâyeleri için.",
    "acts": [
      {
        "title": "Ayrılış",
        "synopsis": "Kahraman bildiği dünyayı terk eder.",
        "chapters": [
          {
            "title": "Sıradan dünya",
            "synopsis": "Macera öncesi kahraman: evi, alışkanlıkları ve eksik olan şey.",
            "scenes": [
              {
                "title": "Sıradan dünya",
                "synopsis": "Macera öncesi kahraman: evi, alışkanlıkları ve eksik olan şey."
              }
            ]
          },
          {
            "title": "Maceraya çağrı",
            "synopsis": "Bir meydan okuma ya da mesaj, sıradan dünyayı sarsar.",
            "scenes": [
              {
                "title": "Maceraya çağrı",
                "synopsis": "Bir meydan okuma ya da mesaj, sıradan dünyayı sarsar."
              }
            ]
          },
          {
            "title": "Çağrının reddi",
            "synopsis": "Korku ya da görev, kahramanı geri tutar.",
            "scenes": [
              {
                "title": "Çağrının reddi",
                "synopsis": "Korku ya da görev, kahramanı geri tutar."
              }
            ]
          },
          {
            "title": "Rehberle karşılaşma",
            "synopsis": "Biri öğüt, eğitim ya da bir armağan sunar.",
            "scenes": [
              {
                "title": "Rehberle karşılaşma",
                "synopsis": "Biri öğüt, eğitim ya da bir armağan sunar."
              }
            ]
          },
          {
            "title": "İlk eşiği geçmek",
            "synopsis": "Kahraman olağanüstü dünyaya girer.",
            "scenes": [
              {
                "title": "İlk eşiği geçmek",
                "synopsis": "Kahraman olağanüstü dünyaya girer."
              }
            ]
          }
        ]
      },
      {
        "title": "Erginlenme",
        "synopsis": "Olağanüstü dünyadaki sınavlar ve büyük çile.",
        "chapters": [
          {
            "title": "Sınavlar, müttefikler ve düşmanlar",
            "synopsis": "Kahraman yeni dünyanın kurallarını öğrenir.",
            "scenes": [
              {
                "title": "Sınavlar, müttefikler ve düşmanlar",
                "synopsis": "Kahraman yeni dünyanın kurallarını öğrenir."
              }
            ]
          },
          {
            "title": "En derin mağaraya yaklaşma",
            "synopsis": "Merkezdeki tehlikeye hazırlık.",
            "scenes": [
              {
                "title": "En derin mağaraya yaklaşma",
                "synopsis": "Merkezdeki tehlikeye hazırlık."
              }
            ]
          },
          {
            "title": "Büyük sınav",
            "synopsis": "Bir ölüm kalım krizi; kahramanın içindeki bir şey ölür.",
            "scenes": [
              {
                "title": "Büyük sınav",
                "synopsis": "Bir ölüm kalım krizi; kahramanın içindeki bir şey ölür."
              }
            ]
          },
          {
            "title": "Ödül",
            "synopsis": "Kahraman hazineyi, bilgiyi ya da uzlaşmayı elde eder.",
            "scenes": [
              {
                "title": "Ödül",
                "synopsis": "Kahraman hazineyi, bilgiyi ya da uzlaşmayı elde eder."
              }
            ]
          }
        ]
      },
      {
        "title": "Dönüş",
        "synopsis": "Eve dönüş yolu, son bir sınav ve kahramanın yanında getirdikleri.",
        "chapters": [
          {
            "title": "Dönüş yolu",
            "synopsis": "Kahraman eve yönelir; çoğu zaman peşindekilerden kaçar.",
            "scenes": [
              {
                "title": "Dönüş yolu",
                "synopsis": "Kahraman eve yönelir; çoğu zaman peşindekilerden kaçar."
              }
            ]
          },
          {
            "title": "Diriliş",
            "synopsis": "Öğrenilen her şeyin kullanıldığı son sınav.",
            "scenes": [
              {
                "title": "Diriliş",
                "synopsis": "Öğrenilen her şeyin kullanıldığı son sınav."
              }
            ]
          },
          {
            "title": "İksirle dönüş",
            "synopsis": "Kahraman değişmiş olarak, paylaşacak bir şeyle eve döner.",
            "scenes": [
              {
                "title": "İksirle dönüş",
                "synopsis": "Kahraman değişmiş olarak, paylaşacak bir şeyle eve döner."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "On beş anlatı adımı",
    "summary": "Senaristlerin kullandığı plan: üç perdeye yayılan on beş dönüm noktası.",
    "bestFor": "Belirgin dönüm noktaları olan sıkı, ticari olay örgüleri için.",
    "metaTitle": "On beş adımlı hikâye şablonu — Musael",
    "metaDescription": "Senaristlerin planı: üç perdede on beş dönüm noktası. Belirgin dönüm noktaları olan sıkı, ticari olay örgüleri için.",
    "acts": [
      {
        "title": "I. Perde",
        "synopsis": "Önceki dünya ve onu terk etme kararı.",
        "chapters": [
          {
            "title": "Açılış görüntüsü",
            "synopsis": "Hikâye öncesinde kahraman ve dünya.",
            "scenes": [
              {
                "title": "Açılış görüntüsü",
                "synopsis": "Hikâye öncesinde kahraman ve dünya."
              }
            ]
          },
          {
            "title": "Temanın söylenmesi",
            "synopsis": "Biri hikâyenin gerçekte ne hakkında olduğunu söyler; kahraman henüz anlayamaz.",
            "scenes": [
              {
                "title": "Temanın söylenmesi",
                "synopsis": "Biri hikâyenin gerçekte ne hakkında olduğunu söyler; kahraman henüz anlayamaz."
              }
            ]
          },
          {
            "title": "Kurulum",
            "synopsis": "Kahramanın hayatı, içindeki insanlar ve düzeltilmesi gerekenler.",
            "scenes": [
              {
                "title": "Kurulum",
                "synopsis": "Kahramanın hayatı, içindeki insanlar ve düzeltilmesi gerekenler."
              }
            ]
          },
          {
            "title": "Katalizör",
            "synopsis": "Hikâyeyi harekete geçiren olay.",
            "scenes": [
              {
                "title": "Katalizör",
                "synopsis": "Hikâyeyi harekete geçiren olay."
              }
            ]
          },
          {
            "title": "Tereddüt",
            "synopsis": "Kahraman ne yapacağı konusunda kararsızdır.",
            "scenes": [
              {
                "title": "Tereddüt",
                "synopsis": "Kahraman ne yapacağı konusunda kararsızdır."
              }
            ]
          },
          {
            "title": "İkinci perdeye geçiş",
            "synopsis": "Kahraman yeni bir yol seçer.",
            "scenes": [
              {
                "title": "İkinci perdeye geçiş",
                "synopsis": "Kahraman yeni bir yol seçer."
              }
            ]
          }
        ]
      },
      {
        "title": "II. Perde",
        "synopsis": "Çıkış fikrinin vaadi, ardından düşüş.",
        "chapters": [
          {
            "title": "Yan hikâye",
            "synopsis": "Temayı taşıyan ikincil hikâye; çoğu zaman bir ilişkidir.",
            "scenes": [
              {
                "title": "Yan hikâye",
                "synopsis": "Temayı taşıyan ikincil hikâye; çoğu zaman bir ilişkidir."
              }
            ]
          },
          {
            "title": "Eğlence ve oyunlar",
            "synopsis": "Çıkış fikrinin vaadi gerçekleşir: okurun aradığı şey.",
            "scenes": [
              {
                "title": "Eğlence ve oyunlar",
                "synopsis": "Çıkış fikrinin vaadi gerçekleşir: okurun aradığı şey."
              }
            ]
          },
          {
            "title": "Orta nokta",
            "synopsis": "Sahte bir zafer ya da yenilgi, riskleri yükseltir.",
            "scenes": [
              {
                "title": "Orta nokta",
                "synopsis": "Sahte bir zafer ya da yenilgi, riskleri yükseltir."
              }
            ]
          },
          {
            "title": "Düşmanlar yaklaşıyor",
            "synopsis": "İçeride kuşku, dışarıda baskı.",
            "scenes": [
              {
                "title": "Düşmanlar yaklaşıyor",
                "synopsis": "İçeride kuşku, dışarıda baskı."
              }
            ]
          },
          {
            "title": "Her şey kaybedildi",
            "synopsis": "Orta noktanın tersi: en dip an.",
            "scenes": [
              {
                "title": "Her şey kaybedildi",
                "synopsis": "Orta noktanın tersi: en dip an."
              }
            ]
          },
          {
            "title": "Ruhun karanlık gecesi",
            "synopsis": "Kahraman kaybettiklerinin yasını tutar ve alınacak dersi bulur.",
            "scenes": [
              {
                "title": "Ruhun karanlık gecesi",
                "synopsis": "Kahraman kaybettiklerinin yasını tutar ve alınacak dersi bulur."
              }
            ]
          }
        ]
      },
      {
        "title": "III. Perde",
        "synopsis": "Ders uygulamaya konur.",
        "chapters": [
          {
            "title": "Üçüncü perdeye geçiş",
            "synopsis": "Yan hikâyeden doğan yeni bir fikir, bir yol açar.",
            "scenes": [
              {
                "title": "Üçüncü perdeye geçiş",
                "synopsis": "Yan hikâyeden doğan yeni bir fikir, bir yol açar."
              }
            ]
          },
          {
            "title": "Final",
            "synopsis": "Kahraman bozulanı düzeltir; artık kalıcı olarak değişmiştir.",
            "scenes": [
              {
                "title": "Final",
                "synopsis": "Kahraman bozulanı düzeltir; artık kalıcı olarak değişmiştir."
              }
            ]
          },
          {
            "title": "Son görüntü",
            "synopsis": "Açılış görüntüsünü yansıtan, sonrasının dünyası.",
            "scenes": [
              {
                "title": "Son görüntü",
                "synopsis": "Açılış görüntüsünü yansıtan, sonrasının dünyası."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Yedi noktalı yapı",
    "summary": "Sondan geriye doğru planla: kanca, dönüşler, baskılar, orta nokta ve çözüm.",
    "bestFor": "Önce sonu bilen yazarlar için.",
    "metaTitle": "Yedi noktalı hikâye şablonu — Musael",
    "metaDescription": "Sondan geriye planla: kanca, dönüşler, baskılar, orta nokta ve çözüm. Önce sonu bilen yazarlar için.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Kanca",
            "synopsis": "Başlangıç durumu; çözümün tam tersi.",
            "scenes": [
              {
                "title": "Kanca",
                "synopsis": "Başlangıç durumu; çözümün tam tersi."
              }
            ]
          },
          {
            "title": "Olay örgüsü dönüşü 1",
            "synopsis": "Çatışma başlar ve kahraman eyleme itilir.",
            "scenes": [
              {
                "title": "Olay örgüsü dönüşü 1",
                "synopsis": "Çatışma başlar ve kahraman eyleme itilir."
              }
            ]
          },
          {
            "title": "Baskı 1",
            "synopsis": "Karşıt karakter baskı kurar; kahraman harekete geçmek zorundadır.",
            "scenes": [
              {
                "title": "Baskı 1",
                "synopsis": "Karşıt karakter baskı kurar; kahraman harekete geçmek zorundadır."
              }
            ]
          },
          {
            "title": "Orta nokta",
            "synopsis": "Kahraman tepki vermekten eyleme geçer.",
            "scenes": [
              {
                "title": "Orta nokta",
                "synopsis": "Kahraman tepki vermekten eyleme geçer."
              }
            ]
          },
          {
            "title": "Baskı 2",
            "synopsis": "İşler çok kötü gider; plan başarısız olur.",
            "scenes": [
              {
                "title": "Baskı 2",
                "synopsis": "İşler çok kötü gider; plan başarısız olur."
              }
            ]
          },
          {
            "title": "Olay örgüsü dönüşü 2",
            "synopsis": "Kahraman kazanmak için gereken son parçayı bulur.",
            "scenes": [
              {
                "title": "Olay örgüsü dönüşü 2",
                "synopsis": "Kahraman kazanmak için gereken son parçayı bulur."
              }
            ]
          },
          {
            "title": "Çözüm",
            "synopsis": "Son durum; kancanın yanıtı.",
            "scenes": [
              {
                "title": "Çözüm",
                "synopsis": "Son durum; kancanın yanıtı."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Çatışma yerine bir dönüş üzerine kurulan dört hareket.",
    "bestFor": "Edebî kurgu, öyküler ve karakter odaklı, sakin kitaplar için.",
    "metaTitle": "Kishōtenketsu hikâye şablonu — Musael",
    "metaDescription": "Çatışma yerine bir dönüş üzerine kurulan dört hareket. Edebî kurgu, öyküler ve karakter odaklı, sakin kitaplar için.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: giriş",
            "synopsis": "Karakterler ve dünyaları sakin biçimde tanıtılır.",
            "scenes": [
              {
                "title": "Giriş",
                "synopsis": "Kim, nerede ve gündelik hayat nasıl görünür?"
              }
            ]
          },
          {
            "title": "Shō: gelişme",
            "synopsis": "Durum derinleşir; henüz bir dönüş yoktur.",
            "scenes": [
              {
                "title": "Gelişme",
                "synopsis": "Karakterleri daha iyi tanırız; küçük şeyler değişir."
              }
            ]
          },
          {
            "title": "Ten: dönüş",
            "synopsis": "Beklenmedik bir unsur, her şeye bakışımızı değiştirir.",
            "scenes": [
              {
                "title": "Dönüş",
                "synopsis": "Yeni ve görünüşte ilgisiz bir şey ortaya çıkar."
              }
            ]
          },
          {
            "title": "Ketsu: bağlanma",
            "synopsis": "Parçalar birleşerek yeni bir anlayış oluşturur.",
            "scenes": [
              {
                "title": "Bağlanma",
                "synopsis": "Dönüş ile hikâye buluşur; anlam değişir."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Polisiye",
    "summary": "Bir suç, ipuçları ve yanlış izlerle ilerleyen bir soruşturma ve okura karşı adil bir açıklama.",
    "bestFor": "Suç romanları, dedektif hikâyeleri ve sıcak polisiyeler için.",
    "metaTitle": "Polisiye hikâye şablonu — Musael",
    "metaDescription": "Bir suç, ipuçları, yanlış izler ve okura karşı adil bir açıklama. Suç romanları, dedektif hikâyeleri ve sıcak polisiyeler için.",
    "acts": [
      {
        "title": "Suç",
        "synopsis": "Bir şeyler yanlıştır ve birinin nedenini bulması gerekir.",
        "chapters": [
          {
            "title": "Keşif",
            "synopsis": "Suç ya da kayboluş.",
            "scenes": [
              {
                "title": "Ceset",
                "synopsis": "Suç ortaya çıkar; ilk izlenimler ve ilk sorular belirir."
              },
              {
                "title": "Dedektif",
                "synopsis": "Kim araştırır ve bu onun için neden önemlidir?"
              }
            ]
          }
        ]
      },
      {
        "title": "Soruşturma",
        "synopsis": "İpuçları, şüpheliler ve yanlış izler.",
        "chapters": [
          {
            "title": "Şüpheliler",
            "synopsis": "Güdüsü ve alibisi olan herkes.",
            "scenes": [
              {
                "title": "Görüşmeler",
                "synopsis": "Her şüphelinin yalan söylemek için bir nedeni olur."
              },
              {
                "title": "İlk ipucu",
                "synopsis": "Sonradan önem kazanacak bir gerçek; okura karşı adil ol."
              }
            ]
          },
          {
            "title": "Yanlış izler",
            "synopsis": "Soruşturma yanlış yöne gider.",
            "scenes": [
              {
                "title": "Yanıltıcı ipucu",
                "synopsis": "Kanıtlar yanlış kişiyi gösterir."
              },
              {
                "title": "Tırmanış",
                "synopsis": "İkinci bir suç ya da tehdit, riskleri yükseltir."
              }
            ]
          },
          {
            "title": "Gizli gerçek",
            "synopsis": "Dedektif, başından beri orada olanı görür.",
            "scenes": [
              {
                "title": "Eksik parça",
                "synopsis": "Küçük bir ayrıntı, önceki ipuçlarını yerine oturtur."
              }
            ]
          }
        ]
      },
      {
        "title": "Gerçeğin açığa çıkışı",
        "synopsis": "Çözüm ve bedeli.",
        "chapters": [
          {
            "title": "Çözümün açıklanması",
            "synopsis": "Her ipucu açıklanır.",
            "scenes": [
              {
                "title": "Gerçeğin açığa çıkışı",
                "synopsis": "Suçlu belirtilir ve akıl yürütme ortaya konur."
              },
              {
                "title": "Sonrası",
                "synopsis": "Adalet ya da yokluğu ve dedektifin yanında götürdükleri."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Aşk hikâyesi",
    "summary": "İki insan, onları ayrı tutan şey ve birbirlerini seçmeleri için gerekenler.",
    "bestFor": "Her ortamda geçen romantik kurgu ve aşk hikâyeleri için.",
    "metaTitle": "Aşk hikâyesi şablonu — Musael",
    "metaDescription": "İki insan, onları ayrı tutan şey ve birbirlerini seçmeleri için gerekenler. Her ortamda geçen romantik kurgu ve aşk hikâyeleri için.",
    "acts": [
      {
        "title": "Âşık olmak",
        "synopsis": "Tanışırlar, direnirler ve âşık olmaya başlarlar.",
        "chapters": [
          {
            "title": "Karşılaşma",
            "synopsis": "Kıvılcımı ve engeliyle ilk karşılaşma.",
            "scenes": [
              {
                "title": "Tanışma",
                "synopsis": "İki ana karakter tanışır; birbirlerinde onları derinden etkileyen bir şey bulurlar."
              },
              {
                "title": "Direnç",
                "synopsis": "Neden yürümeyeceği: hedefler, yaralar ya da koşullar."
              }
            ]
          },
          {
            "title": "Yakınlaşma",
            "synopsis": "Bir arada kalmak zorunda kalarak birbirlerini gerçekten görürler.",
            "scenes": [
              {
                "title": "Tesadüfen birlikte",
                "synopsis": "Bir durum onları yakın tutar."
              },
              {
                "title": "İlk gerçek an",
                "synopsis": "Diğerinin gerçekte kim olduğuna kısa bir bakış."
              }
            ]
          }
        ]
      },
      {
        "title": "Kuşku duymak",
        "synopsis": "Bağlılık ve ardından onu kıran korku.",
        "chapters": [
          {
            "title": "Orta nokta",
            "synopsis": "Hissettiklerine teslim olurlar.",
            "scenes": [
              {
                "title": "Bağlılık",
                "synopsis": "Bir öpücük, itiraf ya da söz."
              }
            ]
          },
          {
            "title": "Kırılma",
            "synopsis": "Eski yara ya da dışarıdaki engel şimdilik kazanır.",
            "scenes": [
              {
                "title": "Kuşku",
                "synopsis": "Eski korkular geri döner."
              },
              {
                "title": "Ayrılık",
                "synopsis": "Ayrılırlar; ikisi de haklı olduğundan emindir."
              }
            ]
          }
        ]
      },
      {
        "title": "Seçmek",
        "synopsis": "Gelişim, büyük bir jest ve ortak gelecek.",
        "chapters": [
          {
            "title": "Birlikte",
            "synopsis": "İkisi de diğerini hak edecek kadar değişir.",
            "scenes": [
              {
                "title": "Büyük jest",
                "synopsis": "Biri değiştiğini göstermek için her şeyi riske atar."
              },
              {
                "title": "Sonsuza dek mutlu",
                "synopsis": "Ya da şimdilik mutlu: seçtikleri gelecek."
              }
            ]
          }
        ]
      }
    ]
  }
}
